import React, {PureComponent} from 'react';
import './form.scss';
import pubsub from 'common/js/pubsub';
import logger from 'common/js/logger';
import loginUtils from 'common/js/login';

export default class Form extends PureComponent {
	constructor(props) {
		super(props)
		this.state = {
			btnCodeActive: true,
			isReging: false,
			tipsMsg: '',
			btnCode: '获取验证码'
		};
		this.getCodeTimer = null;
		this.getCodeTimeStep = 60;

		// 记录触发错误的输入框
		this.errorInput = null;

		this.showTips = this.showTips.bind(this);
		this.hideTips = this.hideTips.bind(this);
		this.inputPhone = this.inputPhone.bind(this);
		this.verifyPhone = this.verifyPhone.bind(this);
		this.inputEvt = this.inputEvt.bind(this);
		this.submit = this.submit.bind(this);
		this.returnLogin = this.returnLogin.bind(this);
		this.checkPhone = this.checkPhone.bind(this);
		this.inputKeyUp = this.inputKeyUp.bind(this);
	}

	componentDidMount() {
		let self = this;

		this._mounted = true;
		pubsub.subscribe('showRegTips', function(type, args) {
			self.showTips(args);
		});
		pubsub.subscribe('hideRegTips', this.hideTips);
	}

	componentWillUnmount() {
		this._mounted = false;
	}

	returnLogin() {
		pubsub.publish('showLoginTab');
	}

	showTips(msg) {
		this._mounted && this.setState({
			tipsMsg: msg
		});
	}

	hideTips() {
		this._mounted && this.setState({
			tipsMsg: ''
		});
	}

	inputKeyUp(e) {
		if(e && (e.keyCode === 13 || e.key === 'Enter')) {
			this.submit();
		}
	}

	inputPhone(e) {
		let cInput = e.currentTarget,
			value = cInput.value;

		cInput.value = value.replace(/[^\d]/, '');

		this.inputEvt(e);
	}

	inputEvt(e) {
		let cInput = e.currentTarget;

		if(!this.errorInput || this.errorInput === cInput){
			this.errorInput = null;
			this.hideTips();
		}
	}

	verifyPhone(e) {
		let cInput = e.currentTarget,
			value = cInput.value;

		if( value && !( /^1[34578]\d{9}$/.test(value) ) ) {
			this.showTips("手机号码输入有误");
			this.errorInput = cInput;
		}
	}



	checkPhone() {
		let self = this,
			cInput = this.refs.regPhone,
			phone = cInput.value;

		if(!phone) {
			this.showTips("请输入手机号码");
			this.errorInput = cInput;

			return;
		}

		if(!( /^1[34578]\d{9}$/.test(phone) )) {
			this.showTips("手机号码输入有误");
			this.errorInput = cInput;

			return;
		}

		if(!this.state.btnCodeActive) {
			return;
		}

		this.setState({
			btnCodeActive: false,
			btnCode: '获取中'
		});

		loginUtils.verifyPhone({
			phone: phone,
			success: function(res) {
				logger.log(res);
				if(res.data.registed) {
					self.showTips("手机号码已注册");
					self._mounted && self.setState({
						btnCodeActive: true,
						btnCode: '获取验证码'
					});
				}else{
					self.getCode(phone);
				}
			},
			fail:function(res) {
				logger.log(res);
				this._mounted && this.setState({
					btnCodeActive: true,
					btnCode: '重新获取'
				});

			}
		})
	}

	getCode(phone) {
		let self = this;

		loginUtils.getCode({
			phone: phone,
			success: function(res) {
				logger.log(res);
				if(res.returnCode === 0) {
					self.countdown();
				}
			},
			fail:function(res) {
				logger.log(res);
				this._mounted && this.setState({
					btnCodeActive: true,
					btnCode: '重新获取'
				});

			}
		})
	}

	submit() {
		let self = this,
			account = this.refs.regPhone.value,
			code = this.refs.regCode.value,
			password = this.refs.regPassword.value;

		if(!/^1[34578]\d{9}$/.test(account)) {
			this.errorInput = this.refs.regPhone;
			this.showTips("请输入正确的手机号码");
			return false;
		}

		if(!code) {
			this.errorInput = this.refs.regCode;
			this.showTips("请输入手机上收到的验证码");
			return false;
		}

		if(!password) {
			this.errorInput = this.refs.regPassword;
			this.showTips("请输入密码");
			return false;
		}

		this._mounted && this.setState({
			isReging: true
		});

		loginUtils.register({
			phone: account,
			password: password,
			code: code,
			success: function(res) {
				pubsub.publish("showSuccessTips", {
					msg: '注册成功',
					type: 'reg',
					phone: account,
					password: password
				});
			},
			fail: function(res) {
				self._mounted && self.setState({
					isReging: false
				});
				self.showTips(res.description || "注册失败，请重试");
			}
		})

	}

	countdown() {
		let self = this;

		clearInterval(this.getCodeTimer);
		this.getCodeTimeStep = 60;

		this.getCodeTimer = setInterval(function() {
			if(self.getCodeTimeStep <= 1) {
				clearInterval(this.getCodeTimer);
				self._mounted && self.setState({
					btnCodeActive: true,
					btnCode: '重新获取'
				});
			}else{
				self._mounted && self.setState({
					btnCodeActive: false,
					btnCode: self.getCodeTimeStep-- + "s"
				});
			}
		}, 1000);
	}

	render() {
		return (
			<div className="m-form m-form-reg">
				{this.state.tipsMsg ? <p className="m-form_tips">{this.state.tipsMsg}</p> : ''}
				<div className="m-form_ipts">
					<div className="item item-acc">
						<input ref="regPhone" type="tel" placeholder="请输入手机号码" maxLength="11" onInput={this.inputPhone} onBlur={this.verifyPhone} onKeyUp={this.inputKeyUp}/>
						<div className={this.state.btnCodeActive ? "r-btn_code" : "r-btn_code off"} onClick={this.checkPhone} >{this.state.btnCode}</div>
					</div>
					<div className="item item-code">
						<input ref="regCode" type="tel" placeholder="请输入收到的验证码" maxLength="6" onInput={this.inputPhone} onKeyUp={this.inputKeyUp}/>
					</div>
					<div className="item item-pwd">
						<input ref="regPassword" type="password" placeholder="请输入密码" maxLength="20" onInput={this.inputEvt} onKeyUp={this.inputKeyUp}/>
					</div>
				</div>

				<div className="m-form_rela">
					<a  href="javascript:void(0)" title="返回登录" onClick={this.returnLogin}>返回登录</a>
				</div>

				<div className="m-form_submit">
					<a type="button" className="submit" href="javascript:void(0)" onClick={this.submit}>{this.state.isReging ? "处理中..." : "注册"}</a>
				</div>

			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/views/login/form/RegForm.jsx